import React, { useState, useEffect, useRef } from "react";
import { useSelector } from "react-redux";
import { get, post, _delete, put } from "util/requests";
import styles from "../drug_management.module.css";
import { Dialog } from "@mui/material";
import LoadingButton from "@mui/lab/LoadingButton";
import RadioGroup from "ui/crfs/radio_group";
import DropDown from "ui/crfs/drop_down";
import Select from "ui/crfs/select";
import Date from "ui/crfs/date";
import Text from "ui/crfs/text";
import ClearIcon from "@mui/icons-material/Clear";
import moment from "moment";
import { arrayHaveCommonItems } from "util/helpers";

export default function ModifyDrugModal(props) {
  const { showingModal = false, setShowingModal, subject_id, RefetchTableData, study_id, drugConfig, sites } = props;

  const permissions = useSelector((state) => state.user.userData.permissions);

  const [spinning, setSpinning] = useState(false);
  const [deleteSpinning, setDeleteSpinning] = useState(false);
  const [deleteConfirm, setDeleteConfirm] = useState(false);
  const [files, setFiles] = useState([]);
  const [valueObj, setValueObj] = useState({});
  const dropMenuRef = useRef(null);
  const uploadRef = useRef(null);

  useEffect(() => {
    if (showingModal.constructor === Boolean) {
      setValueObj({});
      setFiles([]);
    } else {
      setValueObj({
        drug_id: { value: showingModal.drug_id },
        label_id: { value: showingModal.label_id },
        expiry_date: { value: showingModal.expiry_date },
        status: { value: showingModal.status },
        location: { value: showingModal.location },
        sub_location: { value: showingModal.sub_location },
        next_location: { value: showingModal.next_location },
        id: showingModal.id,
        data_from_open: true,
      });
      if (showingModal.file_name) {
        setFiles([{ name: showingModal.file_name, id: showingModal.file_id }]);
      }
    }
    setDeleteConfirm(false);
    setDeleteSpinning(false);
  }, [showingModal]);

  const handleFileChange = (e) => {
    setFiles([e.target.files[0]]);
  };

  const submit_form = (is_update = false) => {
    let data = { subject_id, is_update, id: showingModal.id || null, study_id };
    Object.entries(valueObj).forEach(([key, value]) => {
      if (value?.value) data[key] = value.value;
    });

    let url = is_update ? `/drug/${showingModal.id}` : `/drug`;
    post(url, data).then(() => {
      setShowingModal(false);
      setSpinning(false);
      RefetchTableData();
    });
  };

  const openFile = (id, name) => {
    get(`/presigned_url/${id}`).then((ret) => {
      if (ret.data?.url) {
        window.open(ret.data.url, "_blank");
      }
    });
  };

  const title = showingModal.constructor === Boolean ? "Add Drug" : "Edit Drug";

  const submitDisabled = !(
    valueObj.drug_id?.value &&
    valueObj.label_id?.value &&
    valueObj.expiry_date?.value &&
    valueObj.status?.value &&
    valueObj.location?.value &&
    valueObj.sub_location?.value
  );
  const read_only = false;

  return (
    <Dialog open={showingModal} onClose={() => setShowingModal(false)} maxWidth={800}>
      <div className={styles.modal_wrapper}>
        <div className={styles.modal_title}>{title}</div>
        <input ref={uploadRef} type="file" onChange={handleFileChange} style={{ display: "none" }} />
        <div style={{ width: "100%" }}>
          <DropDown
            field={{
              value_obj: { value: 1 },
            }}
            uval={valueObj.drug_id?.value}
            options={drugConfig.map((d) => ({ value: d.id, label: d.name }))}
            title={"Drug name"}
            orientation={"vertical"}
            onUpdate={(value) => {
              let data = { ...valueObj };
              data.drug_id = { value };
              setValueObj(data);
            }}
            read_only={read_only}
            hideElementMenu
          />
        </div>
        <div style={{ width: "100%" }}>
          <Text
            field={{
              value_obj: valueObj.label_id || { value: "" },
            }}
            title={"Label Identifier"}
            onUpdate={(value_obj) => {
              let data = { ...valueObj };
              data.label_id = value_obj;
              setValueObj(data);
            }}
            read_only={read_only}
            hideElementMenu
          />
        </div>
        <div style={{ width: "100%" }}>
          <Date
            field={{
              value_obj: valueObj.expiry_date || {},
            }}
            title={"Expiry"}
            onUpdate={(value_obj) => {
              let data = { ...valueObj };
              data.expiry_date = value_obj;
              setValueObj(data);
            }}
            read_only={read_only}
            hideElementMenu
          />
        </div>
        <div style={{ width: "100%" }}>
          <DropDown
            field={{
              value_obj: valueObj.status || { value: "" },
            }}
            uval={valueObj.status?.value}
            options={[{ label: "Available", value: "available" }]}
            title={"Status"}
            orientation={"vertical"}
            onUpdate={(value) => {
              let data = { ...valueObj };
              data.status = { value };
              setValueObj(data);
            }}
            read_only={read_only}
            hideElementMenu
          />
        </div>
        <div style={{ width: "100%" }}>
          <DropDown
            field={{
              value_obj: valueObj.location || { value: "" },
            }}
            uval={valueObj.location?.value}
            options={sites.map((s) => ({ label: s.name, value: s.id }))}
            title={"Location"}
            orientation={"vertical"}
            onUpdate={(value) => {
              let data = { ...valueObj };
              data.location = { value };
              setValueObj(data);
            }}
            read_only={read_only}
            hideElementMenu
          />
        </div>
        <div style={{ width: "100%" }}>
          <DropDown
            field={{
              value_obj: valueObj.sub_location || { value: "" },
            }}
            uval={valueObj.sub_location?.value}
            options={[{ label: "Fridge", value: 1 }]}
            title={"Sub Location"}
            orientation={"vertical"}
            onUpdate={(value) => {
              let data = { ...valueObj };
              data.sub_location = { value };
              setValueObj(data);
            }}
            read_only={read_only}
            hideElementMenu
          />
        </div>
        <div style={{ width: "100%" }}>
          <DropDown
            field={{
              value_obj: valueObj.domains || {},
            }}
            options={
              study_id === 1
                ? [
                    { value: "act42", label: "NoNo-42" },
                    { value: "actwhen", label: "Intravenous Thrombolysis" },
                    { value: "bp", label: "Blood Pressure" },
                  ]
                : [{ value: "ecore", label: "Escape-Core" }]
            }
            title={"Next Location (optional)"}
            orientation={"vertical"}
            onUpdate={(value_obj) => {
              let data = { ...valueObj };
              data.domains = value_obj;
              setValueObj(data);
            }}
            read_only={read_only}
            hideElementMenu
          />
        </div>

        {showingModal.constructor === Boolean && showingModal ? (
          <React.Fragment>
            <div className={styles.modal_button_wrapper}>
              <LoadingButton
                disabled={submitDisabled}
                variant="contained"
                loading={spinning}
                onClick={() => {
                  setSpinning(true);
                  submit_form();
                }}
              >
                Submit
              </LoadingButton>
              <LoadingButton disabled={false} variant="outlined" loading={false} onClick={() => setShowingModal(false)}>
                Cancel
              </LoadingButton>
            </div>
          </React.Fragment>
        ) : null}
        {showingModal.constructor !== Boolean && !deleteConfirm && permissions.includes("consent_record_update") ? (
          <React.Fragment>
            <div className={styles.modal_button_wrapper}>
              <LoadingButton
                disabled={false}
                variant="contained"
                loading={spinning}
                onClick={() => {
                  setSpinning(true);
                  submit_form(true);
                }}
              >
                Update
              </LoadingButton>

              <LoadingButton disabled={false} variant="outlined" loading={false} onClick={() => setShowingModal(false)}>
                Close
              </LoadingButton>
            </div>
          </React.Fragment>
        ) : null}

        {showingModal.constructor !== Boolean && !permissions.includes("consent_record_update") ? (
          <div className={styles.modal_button_wrapper}>
            <LoadingButton disabled={false} variant="outlined" loading={false} onClick={() => setShowingModal(false)}>
              Close
            </LoadingButton>
          </div>
        ) : null}
      </div>
    </Dialog>
  );
}
